// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */

import type * as Types from '../../../../../../../../schema';

import fetchGraphql from '@/server/helpers/fetchQuery';
import gql from '@/shared/utils/gql';
export type BoostNotificationQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type BoostNotificationQuery = { __typename?: 'Query', casinoBoostsPublic?: { __typename?: 'CasinoBoostsPublic', id?: string, boostTimers?: { __typename?: 'CasinoBoostsPublicBoostTimerConnection', edges?: Array<{ __typename?: 'CasinoBoostsPublicBoostTimerEdge', node?: { __typename?: 'CasinoBoostsPublicBoostTimer', id: string, boostAmount?: number, claimed?: boolean, rewardClaimDate?: string, currency?: string, timer?: number, timerStartAt?: any, timerEndAt?: any, userId?: string, winAmount?: number, isActive?: boolean, isLimitReached?: boolean, isTimerOver?: boolean, event?: { __typename?: 'CasinoBoostsPublicEvent', id: string, name?: string, closeAt?: any, allowedGames?: string, boostPercentage?: number, maxBoostAmount?: number, maxBetAmount?: number, boostDuration?: number, iAmOptedIn?: boolean } } }> } } };

export type BoostTimerFragment = { __typename?: 'CasinoBoostsPublicBoostTimer', id: string, boostAmount?: number, claimed?: boolean, rewardClaimDate?: string, currency?: string, timer?: number, timerStartAt?: any, timerEndAt?: any, userId?: string, winAmount?: number, isActive?: boolean, isLimitReached?: boolean, isTimerOver?: boolean, event?: { __typename?: 'CasinoBoostsPublicEvent', id: string, name?: string, closeAt?: any, allowedGames?: string, boostPercentage?: number, maxBoostAmount?: number, maxBetAmount?: number, boostDuration?: number, iAmOptedIn?: boolean } };

export type BoostEventFragment = { __typename?: 'CasinoBoostsPublicEvent', id: string, name?: string, closeAt?: any, allowedGames?: string, boostPercentage?: number, maxBoostAmount?: number, maxBetAmount?: number, boostDuration?: number, iAmOptedIn?: boolean };

export const BoostEventFragmentDoc = gql`
    fragment BoostEventFragment on CasinoBoostsPublicEvent {
  id
  name
  closeAt
  allowedGames
  boostPercentage
  maxBoostAmount
  maxBetAmount(currency: "BTC")
  boostDuration
  iAmOptedIn
}
    `;
export const BoostTimerFragmentDoc = gql`
    fragment BoostTimerFragment on CasinoBoostsPublicBoostTimer {
  id
  boostAmount
  claimed
  rewardClaimDate
  currency
  timer
  timerStartAt
  timerEndAt
  userId
  winAmount
  isActive
  isLimitReached
  isTimerOver
  event {
    ...BoostEventFragment
  }
}
    ${BoostEventFragmentDoc}`;
export const BoostNotificationQueryDocument = gql`
    query BoostNotificationQuery {
  casinoBoostsPublic {
    id
    boostTimers(
      first: 1
      filters: {canBeClaimed: true, hasBoostAmount: true}
      sort: {timerStartAt: -1}
    ) {
      edges {
        node {
          ...BoostTimerFragment
        }
      }
    }
  }
}
    ${BoostTimerFragmentDoc}`;

export const getBoostNotificationQuery = async (variables: BoostNotificationQueryVariables) => {
  return fetchGraphql<BoostNotificationQuery, BoostNotificationQueryVariables>(BoostNotificationQueryDocument, "BoostNotificationQuery", { variables });
}